import { defineField, defineType } from 'sanity'
import { richTextContent } from '../../data/richText'

export default defineType({
  title: 'FAQ',
  name: 'faq',
  type: 'object',
  fields: [
    defineField({
      title: 'Layout',
      name: 'layout',
      type: 'string',
      options: {
        list: [
          { title: 'Standard', value: 'standard' },
          { title: 'Accordion', value: 'accordion' },
        ],
      },
      initialValue: 'accordion',
    }),
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Questions',
      name: 'questions',
      type: 'array',
      of: [
        {
          title: 'Question',
          name: 'question',
          type: 'object',
          fields: [
            defineField({
              title: 'Question',
              name: 'text',
              type: 'text',
            }),
            defineField({
              title: 'Plain text answer',
              name: 'answer',
              type: 'text',
              readOnly: true,
            }),
            defineField({
              title: 'Rich text answer',
              name: 'richAnswer',
              type: 'array',
              of: richTextContent,
            }),
          ],
          preview: {
            select: {
              text: 'text',
            },
            prepare(selection: { text?: string }) {
              const { text = 'Question' } = selection
              return {
                title: text,
              }
            },
          },
        },
      ],
    }),
    defineField({
      name: 'structuredData',
      title: 'Structured data',
      type: 'boolean',
      initialValue: false,
      description:
        'Set to true if you want to insert questions and answers as structured metadata into page',
    }),
  ],
})